import type { PropsWithChildren } from "react";
import type { PlaygroundSubSectionLayoutProps } from "./PlaygroundSubSectionLayout.decl";
import { StyledFlex } from "./PlaygroundSubSectionLayout.styled";

export function PlaygroundSubSectionLayout({
  children,
  ...props
}: PropsWithChildren<PlaygroundSubSectionLayoutProps>) {
  return (
    <StyledFlex gap="xxs" flexDirection="column" {...props}>
      {children}
    </StyledFlex>
  );
}
